module.exports = __webpack_public_path__ + "static/media/B7.fbfef5e5.svg";